import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrowserBlocked = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 138,
	height: 68,
	viewBox: "0 0 138 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7882 9.74596C11.7882 10.9098 10.8475 11.8532 9.68705 11.8532C8.52664 11.8532 7.58594 10.9098 7.58594 9.74596C7.58594 8.58214 8.52664 7.63867 9.68705 7.63867C10.8475 7.63867 11.7882 8.58214 11.7882 9.74596Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1944 9.74596C20.1944 10.9098 19.2537 11.8532 18.0933 11.8532C16.9329 11.8532 15.9922 10.9098 15.9922 9.74596C15.9922 8.58214 16.9329 7.63867 18.0933 7.63867C19.2537 7.63867 20.1944 8.58214 20.1944 9.74596Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.6315 33.9832C26.6315 35.7289 25.2204 37.1441 23.4798 37.1441C21.7392 37.1441 20.3281 35.7289 20.3281 33.9832C20.3281 32.2375 21.7392 30.8223 23.4798 30.8223C25.2204 30.8223 26.6315 32.2375 26.6315 33.9832Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.108 33.9832C52.108 35.7289 50.697 37.1441 48.9564 37.1441C47.2157 37.1441 45.8047 35.7289 45.8047 33.9832C45.8047 32.2375 47.2157 30.8223 48.9564 30.8223C50.697 30.8223 52.108 32.2375 52.108 33.9832Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M43.1942 49.7072C44.8609 50.7914 45.801 52.2274 45.801 53.7354C45.801 54.0264 46.0362 54.2622 46.3263 54.2622C46.6164 54.2622 46.8516 54.0264 46.8516 53.7354C46.8516 51.7519 45.6163 50.027 43.7659 48.8232C41.9104 47.6161 39.3785 46.8867 36.6086 46.8867C33.8388 46.8867 31.3068 47.6161 29.4514 48.8232C27.601 50.027 26.3657 51.7519 26.3657 53.7354C26.3657 54.0264 26.6009 54.2622 26.891 54.2622C27.1811 54.2622 27.4163 54.0264 27.4163 53.7354C27.4163 52.2274 28.3563 50.7915 30.0231 49.7072C31.6847 48.6262 34.0116 47.9404 36.6086 47.9404C39.2057 47.9404 41.5326 48.6262 43.1942 49.7072Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6007 9.74596C28.6007 10.9098 27.66 11.8532 26.4996 11.8532C25.3391 11.8532 24.3984 10.9098 24.3984 9.74596C24.3984 8.58214 25.3391 7.63867 26.4996 7.63867C27.66 7.63867 28.6007 8.58214 28.6007 9.74596Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5635 3.59816H65.134C67.1212 3.59816 68.7322 5.20911 68.7322 7.19632V16.2446H3.96535V7.19632C3.96535 5.20911 5.5763 3.59816 7.5635 3.59816ZM0.367188 19.8427V16.2446V7.19632C0.367188 3.2219 3.58909 0 7.5635 0H65.134C69.1084 0 72.3303 3.2219 72.3303 7.19632V16.2446V19.8427V58.9198C72.3303 62.8943 69.1084 66.1162 65.134 66.1162H7.5635C3.58909 66.1162 0.367188 62.8943 0.367188 58.9198V19.8427ZM68.7322 19.8427V58.9198C68.7322 60.907 67.1212 62.518 65.134 62.518H7.5635C5.5763 62.518 3.96535 60.907 3.96535 58.9198V19.8427H68.7322Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.2343 55.8278L84.4685 52.6928C84.0353 51.9237 83.0608 51.6514 82.2917 52.0846C81.5227 52.5177 81.2504 53.4923 81.6835 54.2613L83.4493 57.3964C83.8825 58.1655 84.857 58.4378 85.6261 58.0046C86.3951 57.5715 86.6674 56.5969 86.2343 55.8278ZM86.2111 51.7113C85.2359 49.9798 83.0417 49.3667 81.3102 50.342C79.5788 51.3172 78.9657 53.5114 79.9409 55.2428L81.7067 58.3779C82.6819 60.1094 84.8761 60.7224 86.6076 59.7472C88.339 58.772 88.9521 56.5778 87.9769 54.8463L86.2111 51.7113Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M96.9972 61.0217L93.4097 60.7442C92.5297 60.6761 91.7612 61.3343 91.6931 62.2144C91.625 63.0944 92.2832 63.8629 93.1632 63.931L96.7507 64.2085C97.6307 64.2766 98.3992 63.6184 98.4673 62.7384C98.5354 61.8584 97.8772 61.0898 96.9972 61.0217ZM93.564 58.7502C91.5827 58.5969 89.8523 60.0788 89.699 62.0601C89.5458 64.0414 91.0277 65.7718 93.009 65.9251L96.5964 66.2026C98.5777 66.3559 100.308 64.874 100.461 62.8927C100.615 60.9114 99.1327 59.181 97.1514 59.0277L93.564 58.7502Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M131.175 62.9505C138.056 57.8412 139.491 48.1219 134.382 41.2416C129.273 34.3613 119.554 32.9256 112.673 38.0348C105.793 43.144 104.357 52.8634 109.466 59.7437C114.576 66.6239 124.295 68.0597 131.175 62.9505ZM128.605 40.2083C128.168 39.8705 127.54 39.951 127.202 40.3879C126.864 40.8249 126.945 41.4529 127.382 41.7907C129.637 43.534 130.967 44.9228 131.755 46.3656C132.532 47.7881 132.833 49.3588 132.84 51.5724C132.842 52.1247 133.291 52.5709 133.844 52.5691C134.396 52.5672 134.842 52.1181 134.84 51.5658C134.832 49.1697 134.506 47.2299 133.51 45.4071C132.526 43.6046 130.94 42.0134 128.605 40.2083Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M108.509 57.6231L106.251 59.3002C105.172 60.101 104.947 61.6244 105.748 62.7028C106.549 63.7812 108.072 64.0062 109.151 63.2054L111.409 61.5283C112.487 60.7275 112.713 59.2041 111.912 58.1257C111.111 57.0473 109.588 56.8222 108.509 57.6231ZM105.058 57.6945C103.093 59.1538 102.683 61.9299 104.142 63.8951C105.602 65.8603 108.378 66.2704 110.343 64.8111L112.601 63.134C114.567 61.6746 114.977 58.8985 113.517 56.9333C112.058 54.9681 109.282 54.558 107.317 56.0174L105.058 57.6945Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73.2276 44.6289H69.1797V42.6289H73.2276C76.2639 42.6289 78.7253 45.0903 78.7253 48.1266C78.7253 51.1629 76.2639 53.6243 73.2276 53.6243H69.1797V51.6243H73.2276C75.1593 51.6243 76.7253 50.0583 76.7253 48.1266C76.7253 46.1949 75.1593 44.6289 73.2276 44.6289Z",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 74.4844,
			y: 47.6777,
			width: 10.7945,
			height: 1.79908,
			rx: .89954,
			transform: "rotate(26.6303 74.4844 47.6777)",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 85.0547,
			y: 55.7734,
			width: 10.7945,
			height: 1.79908,
			rx: .89954,
			transform: "rotate(35.0312 85.0547 55.7734)",
			fill: "#8F8E90"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.6172,
			y: 61.7832,
			width: 10.7945,
			height: 1.79908,
			rx: .89954,
			transform: "rotate(-10.4714 96.6172 61.7832)",
			fill: "#8F8E90"
		})
	]
});
export default SvgBrowserBlocked;
